import React, { useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { capitalize } from '../../utils/text'
import moment from 'moment'

import constants from '../../utils/constants'

import LocalStorageService from '../../services/LocalStorageService'
import NotificationService from '../../services/NotificationService'
import UserService from '../../services/UserService'

// Font Awesome

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import Button from '../../components/simple/button/Button'
import DateInput from '../../components/simple/input/DateInput'
import Divider from '../../components/simple/divider/Divider'
import Form from '../../components/simple/form/Form.js'
import FormField from '../../components/simple/formField/FormField.js'
import Select from '../../components/simple/input/Select'
import Tabs from '../../components/simple/tabs/Tabs.js'
import Text from '../../components/simple/text/Text'
import TextInput from '../../components/simple/input/TextInput'


// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'

function ServiceUserNew (props) {

  const navigate = useNavigate();

  const [userDetails, setUserDetails] = useState({
    firstName: '',
    lastName: '',
    email: '',
    reference: '',
    dob: '',
    ethnicity: '',
    gender: ''
  })

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')
  const terms = LocalStorageService.get('terms')

  const params = useParams()

  let userId = params.userid

  // Tab controls
  const [tabIndex, setTabIndex] = useState(0)
  const onActiveTab = (nextIndex) => {

    setTabIndex(nextIndex)
  }

  const ethnicityInput = activeOrg.wondeSync === true ? 
  <TextInput
    name='ethnicity'
    type='text'
  />
  :
  <Select
    name='ethnicity'
    labelKey='label'
    options={constants.ethnicity}
    valueKey={{ key: 'value', reduce: true }}
  />

  const tabContent = [
    {
      name: `${capitalize(terms?.serviceUser || 'Service User')} Details`,
      content: (
        <Form
          onChange={nextValue => {
            setUserDetails(nextValue)
          }}
          onSubmit={({ value: nextValue }) => {
            if (nextValue.dob === '') {
              nextValue.dob = undefined
            }
            submitUserDetails(nextValue)
          }}
          value={userDetails}
        >
          <Divider color='primary' margin={{ top: 'none', bottom: 'medium' }} />

          
          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='First Name'
              name='firstName'
              required
            >
              <TextInput
                name='firstName'
                type='text'
              />
            </FormField>

            <FormField
              label='Last Name'
              name='lastName'
              required
            >
              <TextInput
                name='lastName'
                type='text'
              />
            </FormField>
          </Box>

          <Divider color='lightgrey' margin={{ top: 'medium', bottom: 'medium' }} />

          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='Learner Number (optional)'
              name='reference'
            >
              <TextInput
                name='reference'
                type='text'
              />
            </FormField>

            <FormField
              label='Date of Birth (optional)'
              name='dob'
            >
              <DateInput
                buttonProps={{ backgroundColor: 'white' }}
                // value={(new Date()).toISOString()}
                // onChange={(new Date()).toISOString()}
                format='dd/mm/yyyy'
                name='dob'
              />

            </FormField>
          </Box>



          <Box direction='row-responsive' gap='medium'>
            <FormField
              label='Ethnicity (optional)'
              name='ethnicity'
            >
             { ethnicityInput } 
            </FormField>

            <FormField
              label='Gender (optional)'
              name='gender'
            >
              <Select
                name='gender'
                labelKey='label'
                options={constants.gender}
                valueKey={{ key: 'value', reduce: true }}
              />
              {/* <TextInput
                name='gender'
                type='text'
              /> */}
            </FormField>
          </Box>
          <Divider color='primary' margin={{ top: 'medium', bottom: 'none' }} />
          <Box direction='row' justify='between' margin={{ top: 'medium' }}>
            <Button label='< Back' onClick={() => goBack()} secondary />
            <Button type='submit' label='Save' primary />
          </Box>
        </Form>)
    }]


  // Submit User Details
  const submitUserDetails = async (values) => {

      const data = {
        data: {
          reference: values.reference,
          dob: moment(values.dob).format('YYYY-MM-DD'),
          firstName: values.firstName,
          lastName: values.lastName,
          ethnicity: values.ethnicity,
          gender: values.gender,
          type: 'student'
        },
        organisation: activeOrg.id
      }
      var userAdded = await UserService.createUser(apiToken, data)
      if (userAdded.error) {
        NotificationService.error(userAdded.error)
      } else {
        NotificationService.success(capitalize(terms?.serviceUser || 'Service User') + ' created.')

        userId = userAdded.data.id[0]
        navigate(`/serviceuser/${userId}/profile`)
      }
  }

  const goBack = () => {
    navigate(-1);
  }


  return (
    <Box width='xlarge'>
        <BreadcrumbBar
          title={`New ${capitalize(terms?.serviceUser || 'Service User')}`}
          path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='besmartBlue' size='xsmall'>{window.location.pathname}</Text></>}
        />

      <Box background='white' direction='column' gap='small' round='small' flex='grow'>
         <Box
          gap='small'
          margin={{ horizontal: 'small' }}
          pad='small'
          round='medium'
        >
          <Box direction='column' gap='medium'>
            <Tabs activeIndex={tabIndex} content={tabContent} onActive={onActiveTab} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ServiceUserNew